module.exports = __webpack_public_path__ + "img/amazon-payments.b9bec0f0.png";